(() => {
  const DURATION_MS = 740;
  const EXTRA_DELAY_MS = 280; // max path delay
  const DRAW_MS = DURATION_MS + EXTRA_DELAY_MS; // full rope draw = 1020ms

  const isTouch = () =>
    window.matchMedia("(hover: none)").matches ||
    window.matchMedia("(max-width: 749px)").matches;

  const reducedMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initCard(card) {
    if (card.dataset.shibariInit === "1") return;
    const svg = card.querySelector("svg.shibari-grid");
    if (!svg) return;

    card.dataset.shibariInit = "1";

    svg.querySelectorAll(".rope").forEach((p) => {
      try {
        const len = p.getTotalLength();
        p.style.setProperty("--len", len);
        p.getBoundingClientRect();
      } catch (e) {}
    });

    let leaveTimer = null;
    let drawStartedAt = 0;
    let navigating = false;

    const enter = () => {
      if (leaveTimer) clearTimeout(leaveTimer);
      if (!card.classList.contains("is-hover")) {
        drawStartedAt = performance.now();
      }
      card.classList.add("is-hover");
      card.classList.remove("is-leaving");
    };

    const leave = () => {
      if (navigating) return; // don't retrace while we're waiting to navigate
      card.classList.remove("is-hover"); // retrace
      card.classList.add("is-leaving");  // keep visible while retracing

      leaveTimer = setTimeout(() => {
        card.classList.remove("is-leaving");
      }, DURATION_MS + EXTRA_DELAY_MS + 180);
    };

    card.addEventListener("mouseenter", enter);
    card.addEventListener("mouseleave", leave);
    card.addEventListener("focusin", enter);
    card.addEventListener("focusout", leave);

    // --- Touch devices: let the ropes finish drawing, then open the product ---
    card.addEventListener(
      "click",
      (e) => {
        if (!isTouch() || reducedMotion()) return;

        const link = e.target.closest("a.full-unstyled-link");
        if (!link || !card.contains(link) || !link.href) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        e.preventDefault();

        if (navigating) return; // already counting down; ignore extra taps
        navigating = true;

        enter(); // starts the draw, or keeps an in-progress one running
        const remaining = Math.max(0, DRAW_MS - (performance.now() - drawStartedAt));

        setTimeout(() => {
          window.location.href = link.href;
        }, remaining);
      },
      true
    );
  }

  function scan() {
    document.querySelectorAll(".card").forEach((card) => {
      if (card.querySelector("svg.shibari-grid")) initCard(card);
    });
  }

  document.addEventListener("DOMContentLoaded", scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();